module.exports = __webpack_public_path__ + "static/media/sword-laser.fdd296b4.svg";